<div class="map-controls-container">
  <ng-template #mapControlsContainer></ng-template>
</div>
